import React from "react";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { formatDateReadable } from "../../utilities/helpers";


function isOverdue(dueDateIso) {
  if (!dueDateIso) return false;
  try {
    const due = new Date(dueDateIso + "T00:00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return due < today;
  } catch {
    return false;
  }
}


function CheckInsOpenActionItemsStrip(props) {
  const items = props.items || [];
  const [togglingUuid, setTogglingUuid] = React.useState(null);

  if (items.length === 0) return null;

  const handleClick = async (item) => {
    if (!props.onToggle || togglingUuid) return;
    setTogglingUuid(item.uuid);
    try {
      await props.onToggle(item.uuid);
    } finally {
      setTogglingUuid(null);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-6 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">
          Open action items from previous check-ins
        </h3>
        <span className="text-xs font-medium text-gray-500">{items.length}</span>
      </div>
      <ul className="divide-y divide-gray-100">
        {items.map((item) => {
          const overdue = isOverdue(item.due_date);
          const isToggling = togglingUuid === item.uuid;
          const interactive = !!props.onToggle;
          return (
            <li
              key={item.uuid}
              onClick={interactive ? () => handleClick(item) : undefined}
              className={`px-6 py-3 flex items-center gap-3 text-sm ${
                interactive
                  ? `cursor-pointer hover:bg-violet-50 transition-colors ${
                      isToggling ? "opacity-60" : ""
                    }`
                  : ""
              }`}
            >
              <RadioButtonUncheckedIcon
                className={`shrink-0 ${
                  interactive ? "text-violet-400" : "text-gray-300"
                }`}
                style={{ fontSize: "18px" }}
              />
              <span className="flex-1 text-gray-800 truncate">{item.text}</span>
              {item.due_date && (
                <span
                  className={`text-xs font-medium ${
                    overdue ? "text-rose-600" : "text-gray-500"
                  }`}
                >
                  Due {formatDateReadable(item.due_date)}
                  {overdue && " (overdue)"}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CheckInsOpenActionItemsStrip;
